import { apiClient } from '../../gateways/api'

export { deleteJobSchedule }

const deleteJobSchedule = async (id: string): Promise<void> => {
  await apiClient({
    url: `/rest/beheer/jobschedule/${id}`,
    method: 'DELETE',
  })
}
